import { render, staticRenderFns } from "./IptaStateField.vue?vue&type=template&id=0f1e82f5&"
import script from "./IptaStateField.vue?vue&type=script&lang=js&"
export * from "./IptaStateField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports